import * as React from 'react';

const ExclamationTriangleFilled24 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#ExclamationTriangleFilled24__a)" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m1.303 18.655 8.895-15.583a2.05 2.05 0 0 1 3.604 0l8.895 15.583c.84 1.472-.168 3.345-1.801 3.345H3.104c-1.633 0-2.642-1.873-1.801-3.345M13 13V8.5a1 1 0 1 0-2 0V13a1 1 0 1 0 2 0m-1 3a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
  }
)), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "ExclamationTriangleFilled24__a" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h24v24H0z" }))));
ExclamationTriangleFilled24.Size = 24;
ExclamationTriangleFilled24.Title = "ExclamationTriangleFilled";

export { ExclamationTriangleFilled24 as default };
